var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowTabs = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 36,
    width: 24,
    height: 36,
    rx: 6,
    transform: "rotate(-180 24 36)",
    fill: "#01B075"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2681 11C15.47 11 15.6719 11.1028 15.7729 11.2055C16.0757 11.5138 16.0757 12.0275 15.7729 12.3358L9.91798 17.9872L15.7729 23.7413C16.0757 23.9468 16.0757 24.4606 15.7729 24.7688C15.47 25.0771 14.9653 25.0771 14.6625 24.7688L8.20189 18.5009C8.10095 18.3982 8 18.1927 8 17.9872C8 17.7817 8.10095 17.5761 8.20189 17.4734L14.6625 11.3083C14.8644 11.1028 15.0662 11 15.2681 11Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowTabs);
export default ForwardRef;